import styled from "@emotion/styled";
import { Component } from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";

import { Loader } from "@livechat/design-system";

import { EventPlace, trackEngagement } from "helpers/analytics";
import { hasSubscription } from "helpers/subscription";
import { IInvoice } from "interfaces/entities/invoice";
import { IStoreState } from "interfaces/storeState";
import { IBilling, getBilling } from "store/entities/billing";
import { ISubscription, selectCurrentSubscription } from "store/entities/subscriptions";
import { InvoicesViewActions } from "store/views/invoices/actions";
import { getInvoicesData, getIsFetching } from "store/views/invoices/selectors";

import { SubscriptionInvoicesList } from "./SubscriptionInvoicesList";

interface IStateProps {
  isFetching: boolean;
  invoices: IInvoice[];
  subscription: ISubscription;
  billing: IBilling;
}

interface IDispatchProps {
  fetchInvoices(): void;
}

interface IOwnProps {
  invoiceEmail: string | null;
}

interface IProps extends IOwnProps, IStateProps, IDispatchProps {}

const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 100px;
`;

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export class SubscriptionInvoicesContainerUnconnected extends Component<IProps> {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  componentDidMount() {
    this.props.fetchInvoices();
    trackEngagement("Invoices list: Section opened", EventPlace.Invoices);
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  render() {
    const { isFetching, invoiceEmail, invoices, subscription, billing } = this.props;
    if (isFetching) {
      return (
        <LoaderWrapper>
          <Loader size="medium" />
        </LoaderWrapper>
      );
    }

    const licenseSubscribed = hasSubscription(billing, subscription);

    return (
      <StyledWrapper>
        <SubscriptionInvoicesList invoiceEmail={invoiceEmail} invoices={invoices} hasSubscription={licenseSubscribed} />
      </StyledWrapper>
    );
  }
}

const mapStateToProps = (state: IStoreState): IStateProps => ({
  isFetching: getIsFetching(state),
  invoices: getInvoicesData(state),
  subscription: selectCurrentSubscription(state),
  // @ts-expect-error TS(2322)
  billing: getBilling(state),
});

const mapDispatchToProps = (dispatch: Dispatch): IDispatchProps => ({
  // @ts-expect-error TS(2345)
  fetchInvoices: () => dispatch(InvoicesViewActions.fetchInvoices()),
});

export const SubscriptionInvoicesContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(SubscriptionInvoicesContainerUnconnected);
